import React, { FC, useCallback, useEffect, useState,useContext } from 'react';
import { useParams } from "react-router";
import { 
    Button, Container, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, 
    Table, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, 
    Typography, withStyles 
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { IConsequenceCategory } from "../types/types";
import DialogContentText from "@material-ui/core/DialogContentText";
import { useTask,TasksDispatchContext } from '../stateManagement/context';
import CreateCategoryDialog from './create_category_dialog';
import { get, post, upload } from "../fetchers/fetchers";
import { getConsequenceCategories } from '../stateManagement/data';
import { API_URL } from "../env";

interface IRouteParams {
    id: string
}



const AddingButton = withStyles(theme => ({
    root: {
        margin: "auto",
        backgroundColor: "rgba(0,103,114,0.2)",
        color: "rgba(0,103,114,1)",
        '&:hover': {
            backgroundColor: "rgba(0,103,114,0.5)",
        },
    },
}))(IconButton);
const ConsequenceCategories: FC = () => {
    const params = useParams<IRouteParams>()
    let dispatch = useContext(TasksDispatchContext)
    const [write_access, setWriteAccess] = useState<boolean>(false);
    const [consequenceCategories, setConsequenceCategories] = useState<IConsequenceCategory[]>([]);
    const [createDialogOpen, setCreateDialogOpen] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState<IConsequenceCategory | null>(null);
    const [areYouSure, setAreYouSure] = useState<boolean>(false);

    const tasks = useTask()

    useEffect(() => {
        setWriteAccess(tasks.write_access)
    },[tasks])

    useEffect(() => {
        if (tasks.loaded) {
            setConsequenceCategories(tasks.consequenceCategories)  // Assuming consequenceCategories are present in tasks
        }
    },[ tasks])

    const handleCreate = (newCategory: IConsequenceCategory) => {
        postConsequenceCategory(newCategory)
        // logic for creating a new category
    };

    const handleEdit = (category: IConsequenceCategory) => {
        setSelectedCategory(category);
        setCreateDialogOpen(true);
    };

    const handleAreaYouSure = () => {
        setAreYouSure(false)
        setSelectedCategory(null)
    }

    const handleConfirmDelete = (category: IConsequenceCategory) => {
        setSelectedCategory(category);
        let ra = {...category}
        ra.is_active = false
        postConsequenceCategory(ra)
        setAreYouSure(false)
        setSelectedCategory(null)
    };

    const handleDelete = () => {
        let ra = {...selectedCategory}
        ra.is_active = false
        postConsequenceCategory(ra)
        setAreYouSure(false)
    };

    
    const renderAreYouSure = () => {
        return(
            <Dialog open={areYouSure} onClose={handleAreaYouSure} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Remove  {selectedCategory?.name}</DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        <Typography>
                            Are you sure you want to remove failure mode <b>{selectedCategory?.name}</b>
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleAreaYouSure} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleDelete} color="primary">
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    const postConsequenceCategory = async (consequenceCategory: IConsequenceCategory) => {
        let ra = { ...consequenceCategory };
        delete ra.assessment_project_id;
        delete ra.id;
        delete ra.document;

        await post<IConsequenceCategory>(API_URL + "consequence_category/" + params.id + "/", ra)
        
        getConsequenceCategories(params.id, dispatch)


    }

    return (
        <TableContainer >

{ write_access && <Tooltip title="Add Assessment" placement={'bottom-end'}>
                
                <AddingButton style={{ backgroundColor: "rgb(239,88,43)", color: "#FFFFFF" }}  onClick={() => setCreateDialogOpen(true)} >
                    <AddIcon fontSize="small" />
                </AddingButton>
            </Tooltip> }

            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell align="center">Consequence category information</TableCell>
                        <TableCell align="center">Category</TableCell>
                        <TableCell align="center">Highest severity of damage and loss rating</TableCell>
                        <TableCell align="center">Highest incremental PLL</TableCell>
                        <TableCell align="center">Significant drivers of severity of damage and loss ratings</TableCell>
                        <TableCell align="center">Reference</TableCell>
                        { write_access && <TableCell align="center">


                        </TableCell> }
                    </TableRow>
                </TableHead>

                {consequenceCategories.map((category) => {
                    return (
                        <TableRow key={category.uuid}>
                            <TableCell>{category.name}</TableCell>
                            <TableCell>{category.category}</TableCell>
                            <TableCell>{category.loss_rating}</TableCell>
                            <TableCell align="right">{category.pll}</TableCell>
                            <TableCell>{category.driver_of_severity}</TableCell>
                            <TableCell>{category.document?.name}</TableCell>
                            { write_access &&  <TableCell>
                                <IconButton onClick={() => handleEdit(category)}  component="span" style={{
                        color:"rgb(239,88,43)",

                    }}>
                                    <EditIcon />
                                </IconButton>
                                <IconButton onClick={() => handleConfirmDelete(category)}  component="span" style={{
                        color:"rgb(239,88,43)",

                    }}>
                                    <DeleteIcon />
                                </IconButton>
                            </TableCell> }
                        </TableRow>
                    )
                })}
            </Table>
            { createDialogOpen && <CreateCategoryDialog 
                        conseqenceCategory={ selectedCategory || {
                                        uuid: -1,
                                        name: "",
                                        category: "",
                                        loss_rating: "",
                                        pll: 0,
                                        driver_of_severity: "",
                                        damage: 0,
                                        is_active: true,
                                    }}
                        open={createDialogOpen} 
                        handleClose={() => {
                            setCreateDialogOpen(false);
                            setSelectedCategory(null);  // reset the selected category after the dialog is closed
                        }}
                        handleCreate={handleCreate}
                    />}
        </TableContainer>
    );
}

export default ConsequenceCategories;
